import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { GestionService } from "../../../services/gestion.service";
import { Message, SpinnerService } from "shared-components";

@Component({
  selector: "app-prd-new-edit",
  templateUrl: "./new-edit.component.html",
})
export class PrdNewEditComponent implements OnInit {
  private _producto;
  public newEditForm: UntypedFormGroup;
  public showError: boolean;
  public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
  public mensajes = new Array<Message>();

  @Input() productoId;
  @Output() refresh = new EventEmitter<boolean>();
  @Output() mensaje = new EventEmitter<string>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _spinnerService: SpinnerService,
    private readonly _dataProvider: DataProvider,
    private readonly _gestionService: GestionService
  ) {}

  ngOnInit() {
    this.newEditForm = this._fb.group({
      desProductoDefecto: ["", Validators.required],
    });

    if (this.productoId) {
      this.getProducto();
    }
  }

  private getProducto() {
    this._spinnerService.showSpinner();
    this._gestionService.getProducto(this.productoId).subscribe((resp) => {
      this._spinnerService.hideSpinner();
      this._producto = resp;
      this.newEditForm.patchValue({
        desProductoDefecto: resp.desProductoDefecto,
      });
    }, (error) => {
      this._spinnerService.hideSpinner();
      this.showApiError = true;
      if (error.status === 420) {
        this.mensajes.push({ class: "error", message: "global.error.noAccess" });
      } else {
        this.mensajes.push({ class: "error", message: "global.error.noResponse" });
      }
    });
  }

  public close() {
    this.refresh.emit(false);
  }

  public save() {
    this.checkForm();
    if (this.newEditForm.valid && !this.productoId) {
      this._producto = {
        desProductoDefecto: this.newEditForm.get("desProductoDefecto").value,
      };
      this._spinnerService.showSpinner();
      this._gestionService
        .createProducto(this._producto)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          if (resp.id) {
            this._dataProvider.refreshProductos();
            this.refresh.emit(true);
            this.mensaje.emit("global.success.itemCreated");
          } else {
            this.showError = true;
            this.mensajes.push({
              class: "error",
              message: "global.error.noResponse",
            });
          }
        });
    } else if (this.newEditForm.valid && this.productoId) {
      this._producto = {
        id: this.productoId,
        desProductoDefecto: this.newEditForm.get("desProductoDefecto").value,
      };
      this._spinnerService.showSpinner();
      this._gestionService
        .updateProducto(this._producto)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then(
          (resp) => {
            this._dataProvider.refreshProductos();
            this.refresh.emit(true);
            this.mensaje.emit("global.success.itemUpdated");
          },
          (error) => {
            this.showError = true;
            this.mensajes.push({
              class: "error",
              message: "global.error.noResponse",
            });
          }
        );
    }
  }

  private checkForm() {
    this.showError = this.newEditForm.invalid;
    if (this.showError) {
      this.mensajes.push({ class: "error", message: "global.error.required" });
    }
  }
}
